import { render, staticRenderFns } from "./Alipay.vue?vue&type=template&id=304c8c4c&"
import script from "./Alipay.vue?vue&type=script&lang=js&"
export * from "./Alipay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports